/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertWorkerDto
 */
export interface UpsertWorkerDto {
    /**
     * The endpoint of the worker.
     * @type {string}
     * @memberof UpsertWorkerDto
     */
    endpoint: string;
    /**
     * The API key to authenticate against the worker. Keeps the current key when not defined.
     * @type {string}
     * @memberof UpsertWorkerDto
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the UpsertWorkerDto interface.
 */
export function instanceOfUpsertWorkerDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "endpoint" in value;

    return isInstance;
}

export function UpsertWorkerDtoFromJSON(json: any): UpsertWorkerDto {
    return UpsertWorkerDtoFromJSONTyped(json, false);
}

export function UpsertWorkerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertWorkerDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'],
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
    };
}

export function UpsertWorkerDtoToJSON(value?: UpsertWorkerDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'endpoint': value.endpoint,
        'apiKey': value.apiKey,
    };
}

